<template>
  <div
    id="centerDiv"
    class="mapcontainer"
    style="position: relative"
  >
    <mars-map
      :url="configUrl"
      @onload="onMapload"
      :options="myOptions"
      style="width:100;height:100%"
      v-if="!isCity"
    />
    <!-- <SuperMap
      v-else
      class="superMap"
      :adcode="adcode"
    ></SuperMap> -->
  </div>
</template>

<script>
import MarsMap from "./Map.vue";
import { dataInterface } from "@/api/dataInterfaceApi";
// import SuperMap from "@/components/superMap.vue";
let Map = null; // 全局地图
export default {
  name: "Index",

  components: {
    MarsMap,
    // SuperMap,
  },

  data() {
    const basePathUrl = window.basePathUrl || "";

    return {
      adcode: "",
      isCity: false,
      configUrl: basePathUrl + "config/config.json",
      myOptions: {},
      geoJson: {
        features: [],
      },
      parentInfo: [
        {
          cityName: "全国",
          code: 100000,
        },
      ],
      provinceStationInfo: [], //省站点信息
      featureCollection: {}, //super-feature
      graphicLayer: {},
    };
  },

  mounted() {
    this.myOptions = {
      show: false,
      scene: {
        center: {
          lat: 36.323556,
          lng: 104.780691,
          alt: 8162459,
          heading: 360,
          pitch: -90,
        },
        sceneMode: 1,
      },
    };
  },
  methods: {
    // 地图构造完成回调
    onMapload(map) {
      let that = this;
      Map = map;
      // 以下为演示代码
      console.log(this.configUrl, "configUrl");
      // 创建entity图层
      const graphicLayer = new this.mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayer);

      // 2.在layer上绑定监听事件
      graphicLayer.on(this.mars3d.EventType.click, function (event) {
        console.log("click", event.graphic.attr);

        let data = event.graphic.attr;
        let adcode = data.adcode;
        let type = data.type;
        if (type == "city") {
          //如果是区级，显示区的样式
          console.log(676);
          that.isCity = true;
          that.adcode = adcode;
          return;
        }

        // 省市请求接口
        let updateParams = {};
        if (type == "") {
          updateParams = {
            province: adcode,
          };
          // 110100: '北京市',
          // 120100: '天津市',
          // 500100: '重庆市',
          // 310100: '上海市',
          if ([110000, 120000, 500000, 310000].includes(adcode)) {
            updateParams = {
              city: adcode.toString().substring(0, 2) + "0100",
            };
            that.selectCityStationInfo(updateParams, adcode, type);
          } else {
            that.selectProvinceStationInfo(updateParams);
          }
        } else if (type == "province") {
          if (adcode == "441900") {
            //东莞特殊处理
            that.isCity = true;
            that.adcode = "4419";
            return;
          }
          updateParams = {
            city: adcode,
          };
          that.selectCityStationInfo(updateParams, adcode, type);
        }
        console.log(that.$router, "that.$router");
        that.$router.push({
          path: "/pcnationwideSite",
          query: updateParams,
        });
        // if (window.location.href.indexOf("pcnationwideSite") > -1) {
        //   //TODO:暂时方案，刷新页面
        //   that.$router.go(0);
        // }
      });

      // 可在图层绑定右键菜单,对所有加到这个图层的矢量数据都生效
      graphicLayer.bindContextMenu([
        {
          text: "删除对象",
          iconCls: "fa fa-trash-o",
          callback: function (e) {
            const graphic = e.graphic;
            if (graphic) {
              graphicLayer.removeGraphic(graphic);
            }
          },
        },
      ]);

      if (this.$route.query && this.$route.query.province) {
        this.selectProvinceStationInfo(
          { province: this.$route.query.province },
          graphicLayer,
          map
        );
      } else if (this.$route.query && this.$route.query.city) {
        this.selectCityStationInfo(
          { city: this.$route.query.city },
          "city",
          graphicLayer,
          map
        );
      } else {
        this.selectCountryStationInfo(graphicLayer, map);
      }
    },
    getGeoJson(adcode, type, stationInfo, graphicLayer, map) {
      // type： province||city
      stationInfo = stationInfo.reduce((res, item, index, arr) => {
        if (!res[item.province || item.district || item.city]) {
          res[item.province || item.district || item.city] = item;
        } else {
          res[item.province || item.district || item.city] = {
            ...item,
            chongdianzhuang: `${
              res[item.province || item.district || item.city].chongdianzhuang
            },${item.chongdianzhuang}`,
            huandianzhan: `${
              res[item.province || item.district || item.city].huandianzhan
            },${item.huandianzhan}`,
            status: `${
              res[item.province || item.district || item.city].status
            },${item.status}`,
          };
        }
        if (index === arr.length - 1) {
          return Object.values(res);
        }
        return res;
      }, {});
      let that = this;
      /* eslint-disable */
      AMapUI.loadUI(["geo/DistrictExplorer"], (DistrictExplorer) => {
        var districtExplorer = new DistrictExplorer();
        districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
          if (error) {
            console.error(error);
            return;
          }
          let Json = areaNode.getSubFeatures();
          console.log("geo", Json);
          if (Json.length > 0) {
            const obj = Json.reduce((res, item) => {
              item = item.properties;
              res[item.adcode] = item.center;
              return res;
            }, {});

            console.log("result", obj);
            const result = stationInfo.map((item, index) => {
              // return {
              //   ...item,
              //   latlng:obj[item.province]
              // }
              let pos = obj[item.province || item.city || item.district];
              that.addDemoGraphic6(graphicLayer, item, pos, type);

              if (index == 0 && type) {
                console.log("this.map", pos);
                // Map.setCameraView({ lat: pos[1], lng: pos[0], alt: 20000, heading: 0, pitch: -45 })
                Map.flyToPoint([pos[0], pos[1]], { radius: 10000, heading: 5 });
              }
            });
            console.log("result", result);
          }
        });
      });
    },
    //获取全国站点数据
    selectCountryStationInfo(graphicLayer) {
      let _this = this;
      let params = {
        enCode: "TiDB-guojiaditu-zhandianzhuangtai", //TiDB-全国地图
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          console.log("全国地图", res);
          this.provinceStationInfo = res;
          this.getGeoJson(100000, "", res, graphicLayer);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取省级站点数据
    selectProvinceStationInfo(updateParams, graphicLayer) {
      let _this = this;
      //获取省的站点信息
      let params = {
        enCode: "TiDB-shengjiditu-zhandianzhuangtai", //TiDB-全国地图
        "@province": updateParams.province,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          this.getGeoJson(updateParams.province, "province", res, graphicLayer);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取区级站点数据
    selectCityStationInfo(updateParams, type, graphicLayer) {
      let _this = this;
      //获取省的站点信息
      let params = {
        enCode: "TiDB-shijiditu-zhandianzhuangtai", //TiDB-全国地图
        "@province": updateParams.city,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          this.getGeoJson(updateParams.city, type, res, graphicLayer);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 内置扩展的动态文本 DivBoderLabel
    // addDemoGraphic6(graphicLayer, item, pos, type) {
    //   console.log("addDemoGraphic6", item, pos);
    //   const graphic = new this.mars3d.graphic.DivBoderLabel({
    //     position: pos,
    //     style: {
    //       text: `${this.formatter(item.provinceName)||item.cityName||item.districtName}:${item.countNum}`,
    //       font_size: 20,
    //       font_family: "微软雅黑",
    //       color: "#ccc",
    //       boderColor: "#15d1f2",
    //     },
    //     attr: { type: type, adcode: item.province||item.city||item.district },
    //   });
    //   graphicLayer.addGraphic(graphic);
    // },

    // 内置扩展的动态文本 DivBoderLabel
    addDemoGraphic6(graphicLayer, item, pos, type) {
      console.log("addDemoGraphic6", item, pos);
      let status = (item.status && item.status.split(",")) || "";
      let chongdianzhuang =
        (item.chongdianzhuang && item.chongdianzhuang.split(",")) || "";
      let huandianzhan =
        (item.huandianzhan && item.huandianzhan.split(",")) || "";
      let statusText = "";
      let statusBg = "";
      let centerHtml = "",innerHtml = "";

      if (status) {
        for (let i = 0; i < status.length; i++) {
          if (status[i] == "暂停营业") {
            statusBg = "yellow";
            statusText = "停站";
          } else if (status[i] == "营业中") {
            statusBg = "green";
            statusText = "运营";
          } else if (status[i] == "建设中") {
            statusBg = "white";
            statusText = "建设";
          }
          innerHtml += `<div class="m-r-40 m-t-20 font-20 flex align-center">
                <div class="font-15 m-r-15 flex align-center ${statusBg}" style="white-space:nowrap;">${statusText}:</div>
                <div class="huandianzhan-icon huandianzhan flex align-center ${statusBg}">${huandianzhan[i]}</div>
                <div class="huandianzhan-icon chongdianzhuang flex align-center ${statusBg}">${chongdianzhuang[i]}</div>
              </div>`;
        }

        centerHtml =  `<div style="font-size:0;">
          <div class="marsMapBgTop flex flex-direction justify-center">
            <div class="m-r-40 font-20">${this.formatter(item.provinceName)||item.cityName||item.districtName}:</div>
          </div>
          <div class="marsMapBg flex flex-direction">
              ${innerHtml}
            </div>
            <div class="marsMapBgBottom"></div>
            </div> `

      } else {
        centerHtml = `  <div class="marsMapBgAll flex flex-direction">
                                <div class="m-r-35 font-20">${this.formatter(item.provinceName)||item.cityName||item.districtName}</div>               

                                <div class="m-r-35 font-20 flex align-center">
                                    <div class="huandianzhan-icon huandianzhan flex align-center ${statusBg}">${huandianzhan[0]}</div>
                                    <div class="huandianzhan-icon chongdianzhuang flex align-center ${statusBg}">${chongdianzhuang[0]}</div>
                                </div>
                          </div>  `;
      }
      const graphic = new this.mars3d.graphic.DivGraphic({
        position: pos,
        style: {
          html:centerHtml,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        },
        // hasZIndex: true,
        attr: {
          type: type,
          adcode: item.province || item.city || item.district,
        },
      });
      graphicLayer.addGraphic(graphic);
      // Map.flyToGraphic(graphic, { radius: 10000,scale:5 })
    },
    //格式化数据
    formatter(name) {
      switch (name) {
        case "内蒙古自治区":
          name = "内蒙古";
          break;
        case "西藏自治区":
          name = "西藏";
          break;
        case "新疆维吾尔自治区":
          name = "新疆";
          break;
        case "宁夏回族自治区":
          name = "宁夏";
          break;
        case "广西壮族自治区":
          name = "广西";
          break;
        case "香港特别行政区":
          name = "香港";
          break;
        case "澳门特别行政区":
          name = "澳门";
          break;
        default:
          break;
      }
      return name;
    },
  },
};
</script>

<style>
.mapcontainer {
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.marsMapBgTop {
  width: 214px;
  height: 60px;
  background: url("~@/assets/images/index/mapBgTop.png") repeat;
  background-size: 100% 100%;
  padding-top: 30px;
}
.marsMapBgBottom {
  width: 214px;
  height: 95px;
  background: url("~@/assets/images/index/mapBgBottom.png") repeat;
  background-size: 100% 100%;
}
.marsMapBgAll{
  width: 228px;
  height: 138px;
  background: url("~@/assets/images/index/mapBg.png") repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  padding-top: 30px;
}
.marsMapBg {
  width: 214px;
  /* height: 128px; */
  background: url("~@/assets/images/index/mapBgCenter.png") repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.marsMapBgRed {
  background: url("~@/assets/images/index/mapBg_red.png");
  background-size: 100% 100%;
}
.marsMapBgBlue {
  background: url("~@/assets/images/index/mapBg_blue.png");
  background-size: 100% 100%;
}
.marsMapBgGrey {
  background: url("~@/assets/images/index/mapBg_grey.png");
  background-size: 100% 100%;
}
.m-r-40 {
  margin-left: 25px;
}
.m-r-35 {
  margin-left: 35px;
}
.m-r-15 {
  margin-right: 15px;
}
.m-t-20 {
  margin-top: 20px;
}
.font-15 {
  font-size: 15px;
}
.font-20 {
  font-size: 18px;
}
.huandianzhan-icon {
  position: relative;
  width: 50%;
  padding-left: 30px;
  font-weight: 800;
}
.huandianzhan-icon::before {
}
.huandianzhan::before {
  content: "";
  background: url("~@/assets/images/index/huandianzhan.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 25px;
  height: 15px;
  margin-right: 40px;
  left: 0;
}
.yellow {
  font-weight: 800;
  color: #fedc31;
}

.huandianzhan.yellow::before {
  content: "";
  background: url("~@/assets/images/index/huandianzhanY.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 25px;
  height: 15px;
  margin-right: 40px;
  left: 0;
}

.green {
  font-weight: 800;
  color: #36fbfb;
}
.huandianzhan.green::before {
  content: "";
  background: url("~@/assets/images/index/huandianzhanG.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 25px;
  height: 15px;
  margin-right: 40px;
  left: 0;
}

.chongdianzhuang.green::before {
  content: "";
  background: url("~@/assets/images/index/chongdianzhuangG.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 20px;
  height: 19px;
  margin-right: 35px;
  left: 0;
}
.chongdianzhuang.yellow::before {
  content: "";
  background: url("~@/assets/images/index/chongdianzhuangY.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 20px;
  height: 19px;
  margin-right: 35px;
  left: 0;
}
.chongdianzhuang::before {
  content: "";
  background: url("~@/assets/images/index/chongdianzhuang.png");
  background-size: 100% 100%;
  display: block;
  position: absolute;
  width: 20px;
  height: 19px;
  margin-right: 35px;
  left: 0;
}

.m-b-20{
  margin-bottom:10px;
}
</style>
